import React from 'react';
import PropTypes from 'prop-types';

import './address-card.scss';

const AddressCard = (props) => {
	const { address } = props;

	const showMap = () => {
		window.open(address.mapLink, '_blank');
	};

	const renderCertificateLink = (certificate) => {
		return (
			<li key={certificate.id} className="B16-filter__address-card__list-item">
				<a className="B16-filter__address-card__list-item-text" href={certificate.link}>
					{certificate.name}
				</a>
			</li>
		);
	};

	return (
		<div className="B16-filter__address-card">
			<figure className="B16-filter__address-card__image">
				<picture>
					{/* <source> tags need adding here */}
					<img src={address.image} alt={address.imageAlt} data-object-fit="cover" />
				</picture>
			</figure>
			<div className="B16-filter__address-card__content">
				<div className="B16-filter__address-card__address" itemType="http://microformats.org/profile/h-card" itemScope role="presentation" onClick={showMap}>
					<p itemProp="name"><strong>{address.name}</strong></p>
					<p itemProp="street-address">{address.address1}</p>
					<p itemProp="extended-address">{address.address2}</p>
					<p>
						<span itemProp="locality">{`${address.city}, `}</span>
						<span itemProp="region">{`${address.state} `}</span>
						<span itemProp="postal-code">{address.zip}</span>
					</p>
					<p itemProp="country-name">{address.country}</p>
				</div>
				<div className="B16-filter__address-card__links">
					<ul className="B16-filter__address-card__list">
						{address.certificates.map(renderCertificateLink)}
					</ul>
				</div>
			</div>
		</div>
	);
};

AddressCard.defaultProps = {
	address: {},
};

AddressCard.propTypes = {
	address: PropTypes.shape({}),
};

export default AddressCard;
